import { render, staticRenderFns } from "./ObfuscatedLink.vue?vue&type=template&id=128a138e"
import script from "./ObfuscatedLink.vue?vue&type=script&lang=js"
export * from "./ObfuscatedLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports